export default __webpack_public_path__ + "static/media/IMG-2738.03403d78.jpg";